import { render, staticRenderFns } from "./GeneralDetails.vue?vue&type=template&id=5822a05e&"
import script from "./GeneralDetails.vue?vue&type=script&lang=js&"
export * from "./GeneralDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports